import { render, staticRenderFns } from "./ReportsUnusedTA.vue?vue&type=template&id=6c9d715f&"
import script from "./ReportsUnusedTA.vue?vue&type=script&lang=js&"
export * from "./ReportsUnusedTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports